// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { IndustryOut } from './industryOut.zod.ts';

export const IndustryListOut = zod.object({
  "industries": zod.array(IndustryOut)
});

export type IndustryListOut = zod.input<typeof IndustryListOut>;
export type IndustryListOutOutput = zod.output<typeof IndustryListOut>;
